import { useCallback } from 'react';
import { useDeleteCustomLabelOptionsMutation } from 'graphql/types';

type DeleteCustomLabelReturn = {
  loading: boolean;
  deleteCustomLabelOptions: (id: string) => Promise<string | undefined>;
};
export const useDeleteCustomLabelOptions = (
  onComplete?: () => void
): DeleteCustomLabelReturn => {
  const [
    deleteCustomLabelOptionsMutation,
    { loading }
  ] = useDeleteCustomLabelOptionsMutation();

  const deleteCustomLabelOptions = useCallback(
    async (id: string) => {
      const result = await deleteCustomLabelOptionsMutation({
        variables: {
          input: {
            ids: [id]
          }
        },
        refetchQueries: ['selectLabelOptions'],
        awaitRefetchQueries: true
      });
      onComplete?.();
      return result.data?.deleteCustomLabelOptions.ids[0];
    },
    [deleteCustomLabelOptionsMutation, onComplete]
  );

  return { loading, deleteCustomLabelOptions };
};
